import { Map, Set } from 'immutable'


export const empty = Map()


const ensureSet = values => Set.isSet( values ) ? values : Set.of( values )


// If the lookupTable already contains an index, merge with the existing values.
export const add = ( lookupTable, index, values ) => {
  const valueSet = ensureSet( values )

  return !lookupTable.has( index ) ?
    lookupTable.set( index, valueSet ) :
    lookupTable.update( index, set => set.union( valueSet ))
}


export const remove = ( lookupTable, index, values ) => {
  if ( !lookupTable.has( index )) {
    return lookupTable
  }

  if ( values ) {
    const valueSet = ensureSet( values )

    return lookupTable.update( index, set => set.subtract( valueSet ))
  }

  return lookupTable.remove( index )
}


export const get = ( lookupTable, index ) => lookupTable.get( index )
